<template>
  <v-row justify="start" justify-md="space-around" justify-lg="start" >
    <v-col cols="12" md="10" lg="6">
      <PropertyDetail :darkMode="$props.darkMode"></PropertyDetail>
    </v-col>
    <v-col cols="12" md="10" lg="6">
      <MaintenanceRequestsList class="mb-5" title="Current Maintenance Requests"></MaintenanceRequestsList>
      <RemindersList class="mb-5" title="Current Reminders" ></RemindersList>
    </v-col>
  </v-row>
</template>

<script>
  import PropertyDetail from "../../components/Properties/PropertyDetail";
  import MaintenanceRequestsList from "../../components/Maintenance/MaintenanceRequestsList";
  import RemindersList from "../../components/Reminders/RemindersList";
  import { mapActions } from "vuex";

  export default {
    name: 'PropertyDetailView',
    components: {
      PropertyDetail,
      RemindersList,
      MaintenanceRequestsList
    },
    data: () => ({ }),
    created(){
      this.initialize();
    },
    props:{
      id: String,
      darkMode:{
        type:Boolean,
        default: false
      },
    },
    methods: {
      async initialize() {
        if (this.$props.id){
          await this.setProperty(this.$props.id);
        } else {
          await this.clearProperty();
          this.$router.push('/properties')
        }
      },
      ...mapActions([
        'setProperty',
        'clearProperty',
      ]),

    }
  }
</script>

<style lang="scss" scoped>

</style>